import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import LandingLayout from '../../components/Layouts/LandingLayout'
import {
  MarketingFooter,
  MarketingHeader,
} from '../Marketing/MarketingChrome'
import { brand } from '../../config/settings/brand'
import useDocumentSeo from '../../hooks/useDocumentSeo'
import { Article, Eyebrow, Title, Updated } from './Legal.styles'

const LegalDocument = ({ title, description, children }) => {
  const { pathname } = useLocation()
  useDocumentSeo({
    title: `${title} — ${brand.name}`,
    path: pathname,
    description,
  })

  return (
    <LandingLayout header={<MarketingHeader />} footer={<MarketingFooter />}>
      <Article>
        <Eyebrow>{brand.name}</Eyebrow>
        <Title>{title}</Title>
        <Updated>Última actualización: {brand.legalUpdatedAt}</Updated>
        {children}
      </Article>
    </LandingLayout>
  )
}

LegalDocument.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default LegalDocument
